"use strict";
import { TransactionStepType } from "features/transactions/steps/types";
import { parseERC20ApproveCalldata } from "utils/approvals";
export function createPermit2TransactionStep(txRequest, amountIn, pair) {
  if (!txRequest?.data || !amountIn) {
    return void 0;
  }
  const type = TransactionStepType.Permit2Transaction;
  const token = amountIn.currency.wrapped;
  const { spender } = parseERC20ApproveCalldata(txRequest.data.toString());
  const amount = amountIn.quotient.toString();
  return { type, txRequest, token, spender, amount, pair };
}
